export const NOTIFICATIONS_TAG = "NOTIFICATIONS";
export const SUBSCRIPTIONS_TAG = "SUBSCRIPTIONS";
